import gerenciamentoEnvio from './gerenciamentoEnvio'
import parametrizacao from './parametrizacao'
import relatorioEnvio from './relatorioEnvio'

export default [
    ...gerenciamentoEnvio,
    ...parametrizacao,
    ...relatorioEnvio,
]